/* eslint-disable no-console */
import React from 'react';
//import ReactDOM from 'react-dom';
import ImageGallery from 'react-image-gallery';
import styled from 'styled-components';
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import '../../assets/image-video-gallery-custom.css';

export const EventImageVideoGalleryStyles = {
	PreviewImageContainer: styled.div`
		width: 100%;
		height: 200px;
	`,

	PreviewImage: styled.img`
	&&{
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		}
	`,
	SliderContainer: styled.div`
		width: 100%;
		height: 100%;
	`,
};

const S = EventImageVideoGalleryStyles;

class EventImageVideoGallery extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showVideo: {},
			images: props.images,
			videos: [],
			media: [],
			showFullscreenButton: true,
			showThumbnails: true,
		};
		this.onSlide = this.onSlide.bind(this);
		this.renderVideo = this.renderVideo.bind(this);

		this.state.videos = props.videos
			.map(item => ({
				original: item.original,
				thumbnail: item.thumbnail,
				embedUrl: item.embedUrl,
				originalClass: item.originalClass,
				thumbnailClass: item.thumbnailClass,
				renderItem: this.renderVideo,
			}));
	}

	componentDidMount() {
		this.combineVideoAndImageData();
	}

	onSlide() {
		this.resetVideo();
	}


	combineVideoAndImageData() {
		this.setState({ media: this.state.videos.concat(this.state.images) });
		if (this.state.videos.concat(this.state.images).length === 1) {
			this.setState({ showThumbnails: false });
		}
	}

	toggleShowVideo(url) {
		// eslint-disable-next-line
		this.state.showVideo[url] = !this.state.showVideo[url];
		this.setState({
			showVideo: this.state.showVideo,
			showFullscreenButton: !this.state.showFullscreenButton,
		});
	}

	resetVideo() {
		this.setState({ showVideo: {} });
		this.setState({ showFullscreenButton: true });
	}

	renderVideo(item) {
		return (
			<div className="image-gallery-image">
				{
					this.state.showVideo[item.embedUrl] ?
						<div className="video-wrapper">
							<iframe
								width="100%"
								height="100%"
								src={item.embedUrl}
								frameBorder="0"
								allowFullScreen="allowFullScreen"
								title="video"
								allow="autoplay"
							/>
						</div>
						:
						// eslint-disable-next-line
						<a role="button" onClick={() => { this.toggleShowVideo(item.embedUrl); }} >
							<S.PreviewImageContainer>
								<S.PreviewImage src={item.original} alt="video" />
								{
									item.description &&
									<span className="image-gallery-description">{item.description}	</span>
								}
							</S.PreviewImageContainer>
						</a>

				}
			</div>
		);
	}

	render() {
		return (
			<S.SliderContainer>
				<ImageGallery
					items={this.state.media}
					showNav={false}
					showPlayButton={false}
					showFullscreenButton={this.state.showFullscreenButton}
					onSlide={this.onSlide}
					showThumbnails={this.state.showThumbnails}
				/>
			</S.SliderContainer>
		);
	}
}
export default EventImageVideoGallery;
